import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgObjectContainer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-object-container';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M7.947 4.396A407 407 0 0 0 3.874 6.79c-.026.026.023.144.142.345l.18.305H3.44l.001 4.77v4.77l4.046 2.36a397 397 0 0 0 4.098 2.373c.028.007.127-.122.223-.289.095-.166.181-.301.192-.301s.097.135.192.301c.096.167.195.296.223.289s1.872-1.075 4.098-2.373l4.046-2.36v-4.77l.001-4.77h-.756l.181-.306c.148-.25.171-.315.128-.355-.054-.05-8.008-4.693-8.089-4.722-.024-.008-1.859 1.044-4.077 2.339m7.169 1.189c1.685.982 3.088 1.807 3.116 1.834.042.039-.567.41-3.059 1.863-1.711.998-3.139 1.815-3.173 1.815-.113 0-6.287-3.626-6.245-3.668.074-.074 6.185-3.627 6.241-3.628.031-.001 1.435.802 3.12 1.784M8.593 10.88l2.645 1.54.001 3.67c.001 2.018-.012 3.67-.029 3.669s-1.425-.815-3.13-1.811l-3.1-1.81-.01-3.687-.01-3.688.494.289zm10.397 5.263c-.053.05-6.083 3.569-6.175 3.605-.046.017-.055-.566-.054-3.654l.001-3.674 3.129-1.822 3.129-1.823.01 3.661c.008 2.896 0 3.67-.04 3.707"
    })
  }));
});
export default SvgObjectContainer;